<template>
  <!-- <router-view :key="getProject(project_id).trains.length" height="100%"/> -->
    <router-view height="100%"/>
</template>
<script>
import {
  mapActions,
  mapGetters
} from 'vuex';

// import store from '@/store/index'

import { LiveSyncMixin } from '@/mixins/LiveSync.mixin.js'

export default {
  name: 'Project',
  created(){
    window.addEventListener('beforeunload', this.handlerClose);
    this.startUltraSocket();
    this.syncMilestoneStatus(this.project_id);
  },
  mixins: [
    LiveSyncMixin
  ],
  props: ['project_id'],
  computed: {
    ...mapGetters('Project', [
      'getProject',
      'isLoading',
      'getUpdateKeyTaktPlan'
    ]),
    ...mapGetters('Auth', [
      'isCloudPrint',
    ]),
  },
  methods: {
    ...mapActions('Auth', [
      'resetCloudPrint'
    ]),
    ...mapActions('ProjectStatistics', [
      'resetStatisticSettings',
      'resetFilter'
    ]),
    ...mapActions('ProjectMilestone', [
      'syncMilestoneStatus'
    ]),
    ...mapActions('ProjectStructure', [
      'resetStructure'
    ]),
    handlerClose(){
      this.leaveLiveSyncRoom();
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   // optimize!!
  //   store.dispatch('Ultra/requestUObject', {
  //     url: [
  //       {projects: to.params.project_id},
  //       {additionalinfo: ''},
  //       {showWithEntitiesNormalized: ''}
  //     ]
  //   })
  //   .then(() => {
  //     next();
  //   })
  // },
  beforeRouteLeave(to, from, next) {
      this.leaveLiveSyncRoom();
      this.resetStatisticSettings();
      this.resetFilter();
      this.resetStructure();
      if (this.isCloudPrint) {
        this.resetCloudPrint().then(() => {
          next();
        });
      } else {
      next();
    }
  }
  // }
}
</script>
